exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".about-info {\n  clear: both;\n  padding: 50px 0; }\n  .about-info h3 {\n    font-size: 22px;\n    margin-bottom: 30px; }\n  .about-info p, .about-info li {\n    font-family: 'helveticaneuethin'; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/landing_page/src/app/components/about/about.component.scss
// module id = ../../../../../src/app/components/about/about.component.scss
// module chunks = main